module.exports = __webpack_public_path__ + "fonts/bebasneue_book-webfont.eot";


//////////////////
// WEBPACK FOOTER
// ./web/fonts/bebasneue_book-webfont.eot
// module id = 110
// module chunks = 0